(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const controllers = new Set();

  class VisibleTask {
    constructor(element, start, stop) {
      this.element = element;
      this.startTask = start;
      this.stopTask = stop;
      this.visible = false;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.visible = Boolean(entry?.isIntersecting);
            this.sync();
          },
          { rootMargin: '180px 0px', threshold: 0 }
        );
        this.observer.observe(element);
      } else {
        this.visible = true;
        this.sync();
      }

      controllers.add(this);
    }

    sync() {
      if (this.visible && !document.hidden) this.startTask();
      else this.stopTask();
    }

    disconnect() {
      this.observer?.disconnect();
      this.stopTask();
      controllers.delete(this);
    }
  }

  const initFomo = (element) => {
    const target = element.querySelector('[data-up-fomo-number]');
    if (!target) return;

    const min = Number.parseInt(element.dataset.min || '1', 10);
    const max = Math.max(min, Number.parseInt(element.dataset.max || String(min), 10));
    const interval = Math.max(2000, Number.parseInt(element.dataset.interval || '5000', 10));
    let timer = null;

    const update = () => {
      target.textContent = String(Math.floor(Math.random() * (max - min + 1)) + min);
    };

    const start = () => {
      if (timer) return;
      update();
      timer = window.setInterval(update, interval);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    new VisibleTask(element, start, stop);
  };

  const addBusinessDays = (date, numberOfDays) => {
    const result = new Date(date);
    let counted = 0;

    while (counted < numberOfDays) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) counted += 1;
    }

    return result;
  };

  const initShipping = (element) => {
    const dateTarget = element.querySelector('[data-up-shipping-date]');
    const countdownTarget = element.querySelector('[data-up-shipping-countdown]');
    const days = Math.max(0, Number.parseInt(element.dataset.days || '0', 10));
    const cutoff = Math.min(23, Math.max(0, Number.parseInt(element.dataset.cutoff || '16', 10)));
    const locale = element.dataset.locale || document.documentElement.lang || 'fr-FR';
    let timer = null;

    if (dateTarget) {
      const deliveryDate = addBusinessDays(new Date(), days);
      try {
        dateTarget.textContent = new Intl.DateTimeFormat(locale, {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        }).format(deliveryDate);
      } catch (_) {
        dateTarget.textContent = deliveryDate.toLocaleDateString();
      }
    }

    const updateCountdown = () => {
      if (!countdownTarget) return;

      const now = new Date();
      const target = new Date(now);
      target.setHours(cutoff, 0, 0, 0);
      if (target <= now) target.setDate(target.getDate() + 1);

      const remaining = Math.max(0, target.getTime() - now.getTime());
      const hours = Math.floor(remaining / 3_600_000);
      const minutes = Math.floor((remaining % 3_600_000) / 60_000);
      countdownTarget.textContent = `${hours}h ${String(minutes).padStart(2, '0')}m`;
    };

    const start = () => {
      if (timer) return;
      updateCountdown();
      // L'affichage ne contient pas les secondes : une actualisation par minute suffit.
      timer = window.setInterval(updateCountdown, 60_000);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    new VisibleTask(element, start, stop);
  };

  const initCountdown = (element) => {
    const startTime = Date.parse(element.dataset.start || '');
    const endTime = Date.parse(element.dataset.end || '');
    const clock = element.querySelector('.shortcut-section__clock');

    if (!clock || !Number.isFinite(startTime) || !Number.isFinite(endTime)) {
      element.hidden = true;
      return;
    }

    const targets = {
      days: element.querySelector('[data-countdown-days]'),
      hours: element.querySelector('[data-countdown-hours]'),
      minutes: element.querySelector('[data-countdown-minutes]'),
      seconds: element.querySelector('[data-countdown-seconds]'),
    };

    let timer = null;

    const update = () => {
      const now = Date.now();

      if (now < startTime || now >= endTime) {
        element.hidden = true;
        return;
      }

      element.hidden = false;
      const total = Math.max(0, endTime - now);
      const days = Math.floor(total / 86_400_000);
      const hours = Math.floor((total / 3_600_000) % 24);
      const minutes = Math.floor((total / 60_000) % 60);
      const seconds = Math.floor((total / 1000) % 60);

      if (targets.days) targets.days.textContent = String(days);
      if (targets.hours) targets.hours.textContent = String(hours).padStart(2, '0');
      if (targets.minutes) targets.minutes.textContent = String(minutes).padStart(2, '0');
      if (targets.seconds) targets.seconds.textContent = String(seconds).padStart(2, '0');
    };

    const start = () => {
      if (timer) return;
      update();
      timer = window.setInterval(update, 1000);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    new VisibleTask(element, start, stop);
  };

  const initCssAnimationVisibility = (element) => {
    if (reduceMotion) {
      element.classList.add('is-runtime-paused');
      return;
    }

    new VisibleTask(
      element,
      () => element.classList.remove('is-runtime-paused'),
      () => element.classList.add('is-runtime-paused')
    );
  };

  document.querySelectorAll('[data-up-fomo]').forEach(initFomo);
  document.querySelectorAll('[data-up-shipping]').forEach(initShipping);
  document.querySelectorAll('[data-up-countdown]').forEach(initCountdown);
  document
    .querySelectorAll('.up-scrolling-reviews, up-product-trust-marquee')
    .forEach(initCssAnimationVisibility);

  document.addEventListener('visibilitychange', () => {
    controllers.forEach((controller) => controller.sync());
  });
})();
